import React, { ReactNode } from 'react';
import { Box } from '@mui/material';

export type AccordionFooterProps = {
    actions: ReactNode[];
};

const getActionKey = (index: number): string => `action-${index}`;

export const AccordionFooter: React.FunctionComponent<AccordionFooterProps> = function (props) {
    const { actions } = props;

    const wrapperSx = {
        display: 'flex',
        flexDirection: 'row-reverse',
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '16px 24px',
    };

    return (
        <Box
            data-testid="accordion-footer"
            sx={wrapperSx}
        >
            {actions.map((action, index) => (
                <Box key={getActionKey(index)}>{action}</Box>
            ))}
        </Box>
    );
};
